module.exports = __webpack_public_path__ + "error-bg.48d61f016cb4f54bc87a.jpg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/assets/images/error-bg.jpg
// module id = ../../../../../src/assets/images/error-bg.jpg
// module chunks = main